module.exports = __webpack_public_path__ + "static/img/poker.afcc53cc.png";